// extracted by mini-css-extract-plugin
export var activityContainer = "_fn-0";
export var typingIndicatorContainer = "_fn-1";
export var typingIndicatorDot = "_fn-2";
export var wave = "_fn-3";